<template>
  <div id="assist">
    <NavFooter />
    <Phone
      v-if="isShowPhone"
      v-on:close="isShowPhone = false"
      v-on:auth="isAuth = $event"
      title="注册一下吧，领取新人礼包"
    />
    <Poster v-if="isShowPoster" :selectedRule="selectedRule" v-on:close="isShowPoster = false" />
    <Top />
    <div v-if="rules === undefined || selectedRule === undefined" class="empty">
      <InlineLoading />
    </div>
    <Error v-else-if="!rules" title="该活动不存在" sub="您暂时无法参与助力，看看其他活动吧！" :showButton="true" />
    <div v-else>
      <Choose
        v-if="isShowChoose"
        :rules="rules"
        v-on:choose="setRule($event)"
        v-on:close="isShowChoose = false"
      />
      <Rule
        btnType="reward"
        v-on:phone="isShowPhone = true"
        :selectedRule="selectedRule"
        v-on:choose="isShowChoose = true"
      />
      <Start
        v-on:phone="isShowPhone = true"
        v-on:poster="getPoster"
        v-on:choose="isShowChoose = true"
        :selectedRule="selectedRule"
      />
    </div>
  </div>
</template>

<script>
import Top from "./Top"
import Rule from "./Rule"
import Start from "./Start"
import Error from "./Error"
import Choose from "./Choose"
import Poster from "./Poster"
import Phone from "@/components/assist/Phone"
import Auth from "@/components/assist/Auth"
import NavFooter from "@/components/public/footer"
import Dialog from "mand-mobile/lib-vw/dialog"
export default {
  name: "InviteAssist",
  components: { Top, Rule, Start, NavFooter, Error, Choose, Poster, Phone, Auth },
  data() {
    return {
      isShowChoose: false,
      isShowPoster: false,
      isShowPhone: false,
      isAuth: true,
      rules: undefined,
      selectedRule: undefined,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  watch: {
    user: function () {
      this.wxShare()
    },
  },
  methods: {
    async getRules() {
      this.rules = await this.$api.assist.RULE(1)
    },
    async getSelectedRule() {
      const res = await this.$api.assist.SELECTED_RULE()
      if (res) {
        this.selectedRule = res.find(item => item.type == 1) || null
      } else {
        this.selectedRule = null
      }
    },
    async setRule(rule) {
      if (this.$moment(rule.end_time).isBefore(this.$moment(), "second")) {
        return Dialog.confirm({
          title: "活动已结束",
          content: "来晚啦！没关系，赠您 220G 启蒙英语必备资源，快给宝贝领取吧~",
          confirmText: "立即领取",
          cancelText: "取消",
          onConfirm: () => {
            window.location.replace("https://cdn.anyteach.cn/img/share/wechat-group.png")
          },
        })
      }
      const code = await this.$api.assist.SET_RULE(rule.id)
      if (code === "1000") {
        this.selectedRule = rule
        this.$toastSuccess("选择成功，正在生成海报")
        this.getPoster()
      } else {
        this.$toastError("选择失败，请刷新重试或联系小管家")
      }
    },

    async getPoster() {
      this.isShowPoster = true
    },

    wxShare() {
      this.$wxConfig()
      const title = "助力赢课时 - AnyTeach"
      const desc = "最高赢取 30 天欧美外教少儿英语直播课，免费晋升城市合伙人"
      const imgUrl = "https://cdn.anyteach.cn/img/assist/icon_v2.jpg"
      const link = `${window.homePageUrl}/assist/rule`

      const success = () => {
        Sentry.captureMessage(`${this.user.name} ${this.user.user_id} 分享助力规则 ${link}`)
      }
      const cancel = () => {
        Sentry.captureMessage(`${this.user.name} ${this.user.user_id} 取消分享助力规则 ${link}`)
      }
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title,
          desc,
          link,
          imgUrl,
          success,
          cancel,
        })
        wx.updateTimelineShareData({
          title,
          link,
          imgUrl,
          success,
          cancel,
        })
      })
    },
  },
  created() {
    this.getRules()
    this.getSelectedRule()
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
#assist {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;

  .empty {
    height: 30vh;
  }
}
</style>
